module.exports = __webpack_public_path__ + "img/bul_component_category.b1d03c37.svg";